import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Skeleton } from "@mui/material";

import { PaymentTableInvoiceMenuIcon } from "../../../../../assets/icons/MUI/PaymentIcons";

import { BodyCellStyle, HeadCellStyle } from "./tableStyles";

const PaymentTableLoading = () => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table aria-label="payments table">
        <TableHead>
          <TableRow>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.amount")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.invoiceNum")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.status")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.paidBy")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.email")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.category")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.paidAt")}</TableCell>
            <TableCell sx={HeadCellStyle}>{t("pages.payment.paymentLinks.created")}</TableCell>
            <TableCell
              sx={{
                borderBottom: "1px solid var(--Gray-200, #EAECF0)",
                background: "var(--Gray-50, #F9FAFB)",
                padding: "12px 16px",
              }}
            />
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(5)].map((_, index) => (
            <TableRow key={index}>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={80} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={100} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={60} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={100} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={150} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={80} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={90} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <Skeleton variant="text" width={90} />
              </TableCell>
              <TableCell sx={BodyCellStyle}>
                <PaymentTableInvoiceMenuIcon />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PaymentTableLoading;
